export * from "./ai-text-improve.schema";
export * from "./api/get-holidays.schema";

import type { z } from "zod";

export function getZodDefaults<T extends z.ZodRawShape>(schema: z.ZodObject<T>) {
	const defaulted: any = {};
	const shape = schema.shape;

	// Partial<$InferObjectOutput<T, {}>>
	for (const key in shape) {
		const field = shape[key];

		try {
			const parsed = (field as any)._def.defaultValue?.();
			if (parsed !== undefined) {
				defaulted[key] = parsed;
			}
		} catch {}
	}
	return defaulted as any;
}
